export enum Errors {
  SERVICE_NOT_AVAILABLE = 500,
}
